import { Base } from '@studiometa/js-toolkit';

/**
 * ProductVariants
 */
export default class ProductVariants extends Base {
  static config = {
    name: 'ProductVariants',
    refs: ['color[]', 'image[]'],
  };

  currentIndex = 0;

  /**
   * Au clic sur une pastille de couleur
   * @param {object} props
   * @param {number} props.index
   */
  onColorClick({ index }) {
    if (index === this.currentIndex) return;

    const previousImage = this.$refs.image[this.currentIndex];
    const nextImage = this.$refs.image[index];

    // Réinitialiser tous les z-index d'abord
    this.$refs.image.forEach((img) => {
      img.style.zIndex = '';
    });

    // L'ancienne image reste visible en dessous (z-index: 1)
    previousImage.style.zIndex = 1;

    // La nouvelle image passe au-dessus (z-index: 2) et se révèle
    nextImage.style.zIndex = 2;
    nextImage.classList.add('is-active');

    // Après la transition, nettoyer
    nextImage.addEventListener(
      'transitionend',
      () => {
        previousImage.classList.remove('is-active');
        previousImage.style.zIndex = '';
      },
      { once: true },
    );

    // Mettre à jour les pastilles
    this.$refs.color[this.currentIndex].classList.remove('is-active');
    this.$refs.color[index].classList.add('is-active');

    this.currentIndex = index;
  }
}
